import {
  CircleIcon,
  FlameIcon,
  CheckCircleIcon,
  XCircleIcon,
  IssueClosedIcon,
} from "@primer/octicons-react";

export enum FeedbackStatus {
  NEW = "NEW",
  IN_WORK = "IN_WORK",
  ACCEPTED = "ACCEPTED",
  REJECTED = "REJECTED",
  // Жалоба разобрана без блокировки объекта (ALX-60297).
  // Перечисление общее для обращений, предложений и жалоб, поэтому статус виден во всех трёх.
  PROCESSED = "PROCESSED",
}

export function getFeedbackStatusLabel(status: FeedbackStatus): string {
  switch (status) {
    case FeedbackStatus.NEW:
      return "Новый";
    case FeedbackStatus.IN_WORK:
      return "В работе";
    case FeedbackStatus.ACCEPTED:
      return "Принято";
    case FeedbackStatus.REJECTED:
      return "Отклонено";
    case FeedbackStatus.PROCESSED:
      return "Обработана";
  }
}

export function getFeedbackStatusColor(status: FeedbackStatus): string {
  switch (status) {
    case FeedbackStatus.NEW:
      return "#FD8C73";
    case FeedbackStatus.IN_WORK:
      return "#0969DA";
    case FeedbackStatus.ACCEPTED:
      return "#1A7F37";
    case FeedbackStatus.REJECTED:
      return "#F04040";
    case FeedbackStatus.PROCESSED:
      return "#8250DF";
  }
}

export interface FeedbackStatusUpdateRequest {
  ids: string[];
  status: FeedbackStatus;
}

export const statusFilterConfig = {
  [FeedbackStatus.NEW]: {
    label: "Новые",
    icon: CircleIcon,
  },
  [FeedbackStatus.IN_WORK]: {
    label: "В работе",
    icon: FlameIcon,
  },
  [FeedbackStatus.ACCEPTED]: {
    label: "Принятые",
    icon: CheckCircleIcon,
  },
  [FeedbackStatus.REJECTED]: {
    label: "Отклоненные",
    icon: XCircleIcon,
  },
  [FeedbackStatus.PROCESSED]: {
    label: "Обработанные",
    icon: IssueClosedIcon,
  },
};
